import { useQuery, useMutation } from "@tanstack/react-query";
import { GET } from "../../../../services/index";

// ไทม์ไลน์ log: เปิด/ปิดหน้าที่ + ตอกบัตร/ออนไลน์-ออฟไลน์
// ใช้ useMutation (กดปุ่มค้นหาเอง) ไม่ใช่ query อัตโนมัติ — หน้ารายงานห้ามยิงถี่
export const useFetchActivityTimeline = () => {
  return useMutation({
    mutationFn: async ({ startDate, endDate, userId }) => {
      const params = new URLSearchParams({ startDate, endDate });
      if (userId) params.append("userId", userId);
      return await GET(`/api/v1/activityLog/timeline?${params.toString()}`);
    },
  });
};

// รายชื่อพนักงานสำหรับ dropdown filter (ชุดเดียวกับหน้ารายงานเข้า-ออกงาน)
export const useFetchEmployeeOptions = () => {
  const companyId = sessionStorage.getItem("activeCompanyId");
  return useQuery(
    ["activityLogEmployeeOptions", companyId],
    async () => {
      const { result } = await GET(`/api/v1/users/list/${companyId}`);
      return (result || []).map((u) => ({ value: String(u.id), label: u.UserName }));
    },
    { enabled: !!companyId }
  );
};
